// removed by extract-text-webpack-plugin
module.exports = {"base":"_2R3HI","container":"_1dOXV","navItemList":"_3aoNv","navItem":"_3vgVt","isActive":"bHD4S","back":"_1dsYf","icon":"_6kNte","plusButton":"_3yHOS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner/Banner.scss
// module id = 1784
// module chunks = 0